@if (state().loading) {
  <div class="customer-assignment-badges" aria-hidden="true">
    <span class="ni-shimmer assignment-pill--skeleton"></span>
    <span class="ni-shimmer assignment-pill--skeleton"></span>
  </div>
} @else if (state().isResponsible || state().isCoordinator) {
  <div class="customer-assignment-badges">
    @if (state().isResponsible) {
      <span class="assignment-pill">Estou Atribuído</span>
    }
    @if (state().isCoordinator) {
      <span class="assignment-pill">Sou Coordenador</span>
    }
  </div>
}
